import {computed, effect, inject, Injectable, signal} from '@angular/core';
import {LocationResponse} from '../../api/models/location-response';
import {Api} from '../../api/api';
import {get} from '../../api/functions';
import {rxResource} from '@angular/core/rxjs-interop';
import {from} from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationStateService {
  private readonly api = inject(Api);
  private readonly locationResource = rxResource<LocationResponse[], any>({
    defaultValue: environment.showDefault ? [
      {
        "id": "d94f2601-bdea-4886-9218-88ade821a798",
        "name": "2Kanter",
        displayChart: {
          batteryCharge: {minkWh: 0, maxkWh: 100},
          batteryOrigin: {minkWh: -15, maxkWh: 15},
          batteryPower: {minkWh: -15, maxkWh: 15},
          consumption: {minkWh: 0, maxkWh: 15},
          consumptionOrigin: {minkWh: 0, maxkWh: 15},
          grid: {minkWh: -15, maxkWh: 15},
          gridOrigin: {minkWh: -15, maxkWh: 15},
          performance: {minkWh: 0, maxkWh: 15},
          performanceOrigin: {minkWh: 0, maxkWh: 15},
        },
      },
      {
        "id": "39d05169-ee83-45f0-87b4-2ac161ac0605",
        "name": "Klammühle",
        displayChart: {
          batteryCharge: {minkWh: 0, maxkWh: 100},
          batteryOrigin: {minkWh: -120, maxkWh: 120},
          batteryPower: {minkWh: -120, maxkWh: 120},
          consumption: {minkWh: 0, maxkWh: 120},
          consumptionOrigin: {minkWh: 0, maxkWh: 120},
          grid: {minkWh: -120, maxkWh: 120},
          gridOrigin: {minkWh: -120, maxkWh: 120},
          performance: {minkWh: 0, maxkWh: 120},
          performanceOrigin: {minkWh: 0, maxkWh: 120},
        },
      }
    ] :[],
    stream: () => from(this.api.invoke(get)),
  });

  readonly currentLocation = signal<LocationResponse | undefined>(undefined);
  readonly minMaxOriginEnergy = computed(() => 120);

  readonly locations = computed(() => {
    const val = this.locationResource.hasValue() ? this.locationResource.value() : undefined;
    return val ? [...val].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')) : [];
  });

  constructor() {
    effect(() => {
      const data = this.locations();
      if (data && data.length > 0) {
        this.currentLocation.set(data[0]);
      }
    });
  }

  setLocation(location: LocationResponse) {
    this.currentLocation.set(location);
  }
}
